import { capture } from "./capture";

export const AuthTracking = {
  /** Login form submitted. */
  loginSubmitted: (loginType: string) => {
    capture("auth.login_submitted", { login_type: loginType });
  },

  /** Login API succeeded. */
  loginSucceeded: (loginType: string, isOnboarded: boolean) => {
    capture("auth.login_succeeded", { login_type: loginType, is_onboarded: isOnboarded });
  },

  /** Login API failed. */
  loginFailed: (loginType: string, error: string) => {
    capture("auth.login_failed", { login_type: loginType, error });
  },

  /** Registration form submitted. */
  registerSubmitted: (registerType: string) => {
    capture("auth.register_submitted", { register_type: registerType });
  },

  /** Registration API succeeded. */
  registerSucceeded: (registerType: string) => {
    capture("auth.register_succeeded", { register_type: registerType });
  },

  /** Registration API failed. */
  registerFailed: (registerType: string, error: string) => {
    capture("auth.register_failed", { register_type: registerType, error });
  },

  /** Free user instance created. */
  freeSignupInstanceCreated: (sourceInsight: string) => {
    capture("auth.free_signup_instance_created", { source_insight: sourceInsight });
  },
};
